<template>
  <div class="mo_new" id="example-1">
    <header class="header" v-if="hederShow">
      <button type="button" class="nav_button" @click="navVisible = true">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="10" y="10" width="20" height="2" fill="black" />
          <rect x="10" y="18" width="20" height="2" fill="black" />
          <rect x="10" y="26" width="20" height="2" fill="black" />
        </svg>
        <span class="blind">메뉴열기</span>
      </button>
    </header>
    <nav class="nav" :class="{ nav_open: navVisible }">
      <div class="nav_bg" @click="navVisible = false"></div>
      <ul class="nav_menu">
        <li @click="goSlide(1)">About</li>
        <li @click="goSlide(2)">Careers</li>
        <li @click="goSlide(3)">이용약관</li>
      </ul>
    </nav>
    <div id="ministockContent2" class="ministock_container">
      <!-- 메인 탑 -->
      <section class="section_main">
        <h2>
          <img
            src="~@/assets/images/mo_new/img_main_tit.png"
            class="main_tit"
            alt="매일이 즐거운 투자루틴"
          />
        </h2>
        <img
          src="~@/assets/images/mo_new/img_main_txt01.svg"
          class="main_txt01"
          alt="초보자부터 숙련된 투자자까지 안전하고 편리한 최고의 투자 환경을 경험해보세요."
        />
        <img
          src="~@/assets/images/mo_new/img_main_txt02.svg"
          class="main_txt02"
          alt="미니스탁은 투자에 대한 귀중한 경험을 쉽게 쌓아갈 수 있도록 도와드립니다."
        />
      </section>
      
      <!-- 슬라이드 소개 -->
      <section class="section_slide">
        <div
          id="bgSlide"
          :class="{
            show00: slideCount === 0,
            show01: slideCount === 1,
            show02: slideCount === 2,
            show03: slideCount === 3,
            show04: slideCount === 4,
            show05: slideCount === 5 || slideCount === 6,
          }"
        >
          <!-- 화면 높이에  따라서 show01 show02 show03 show04 show05가 바껴야 함 -->
          <h2>
            <img
              src="~@/assets/images/mo_new/img_slide_tit.svg"
              class="slide_tit"
              alt="smile season3"
            />
            <div class="slider-pagination">
              <span class="slider-pagination-bullet"></span>
              <span class="slider-pagination-bullet"></span>
              <span class="slider-pagination-bullet"></span>
              <span class="slider-pagination-bullet"></span>
              <span class="slider-pagination-bullet"></span>
            </div>
          </h2>
          <div class="items item01">
            <div class="slide_txtarea">
              <p class="slide_txt01">한국주식까지</p>
              <p class="slide_txt02">실시간으로 쉽게<br />투자해 보세요.</p>
            </div>
            <div
              class="slide_imgarea full"
              id="slide_lottie1"
              v-show="slideCount !== 6"
            >
              <!-- <img
                src="~@/assets/images/mo_new/slide/img01.png"
                class="slide_img"
              /> -->
            </div>
          </div>
          <div class="items item02">
            <div class="slide_txtarea">
              <p class="slide_txt01">똑똑한 주식상세</p>
              <p class="slide_txt02">
                AI가 한 문장으로 요약해드려요.<br />AI와 전문가들이 꼼꼼하게
                알려드려요.
              </p>
            </div>
            <div
              class="slide_imgarea"
              id="slide_lottie2"
              v-show="slideCount !== 6"
            >
              <!-- <img
                src="~@/assets/images/mo_new/slide/img02.png"
                class="slide_img"
              /> -->
            </div>
          </div>
          <div class="items item03">
            <div class="slide_txtarea">
              <p class="slide_txt01">홈</p>
              <p class="slide_txt02">
                쓱 - 밀어서 내 보유주식보고,<br />관심주식보고 금융 트랜드도
                발견하고<br />핫한 랭킹 확인까지
              </p>
            </div>
            <div
              class="slide_imgarea"
              id="slide_lottie3"
              v-show="slideCount !== 6"
            >
              <!-- <img
                src="~@/assets/images/mo_new/slide/img03.png"
                class="slide_img"
              /> -->
            </div>
          </div>
          <div class="items item04">
            <div class="slide_txtarea">
              <p class="slide_txt01">자산</p>
              <p class="slide_txt02">
                내 투자 현황과<br />투자 진행사항을 한눈에<br />볼 수 있어요.
              </p>
            </div>
            <div
              class="slide_imgarea"
              id="slide_lottie4"
              v-show="slideCount !== 6"
            >
              <!-- <img
                src="~@/assets/images/mo_new/slide/img04.png"
                class="slide_img"
              /> -->
            </div>
          </div>
          <div class="items item05">
            <div class="slide_txtarea">
              <p class="slide_txt01">신용/대출</p>
              <p class="slide_txt02">
                투자금이 필요할때 신용/대출도<br />미니스탁에서 편하게 사용
                하세요.
              </p>
              <p class="slide_txt03">
                *신용/대출은 초고위험 상품이며 투자원금 초과 손실이 발생할 수
                있으니,<br />주요 안내사항을 충분히 숙지하신 후 신청 및
                거래하시기 바랍니다.
              </p>
            </div>
            <div
              class="slide_imgarea"
              id="slide_lottie5"
              v-show="slideCount !== 6"
            >
              <!-- <img
                src="~@/assets/images/mo_new/slide/img05.png"
                class="slide_img"
              /> -->
            </div>
          </div>
        </div>
      </section>

      <!-- 쉽게 다 되는 투자 플랫폼  -->
      <section class="section_platform">
        <h2>
          <img
            src="~@/assets/images/mo_new/img_platform_tit.svg"
            class="platform_tit"
            alt="쉽게 다 되는 투자 플랫폼"
          />
        </h2>
        <div class="platform_container">
          <div class="platform_item">
            <img
              src="~@/assets/images/mo_new/platform/img01.png"
              class="platform_img"
              alt="trading 실시간 투자 한국주식, 미국주식, ETF까지"
            />
          </div>
          <div class="platform_item">
            <img
              src="~@/assets/images/mo_new/platform/img02.png"
              class="platform_img"
              alt="investment 소수점 투자 1,000원부터 해외주식에 투자할 수 있어요."
            />
          </div>
          <div class="platform_item">
            <img
              src="~@/assets/images/mo_new/platform/img03.png"
              class="platform_img"
              alt="investment 자동투자 설정 한번에 알아서 척척 마음 편하게 투자할 수 있어요."
            />
          </div>
          <div class="platform_item">
            <img
              src="~@/assets/images/mo_new/platform/img04.png"
              class="platform_img"
              alt="investment 배당주 투자 계좌속 깜짝선물 배당주, 배당금 확인도 쉽고 빨라요."
            />
          </div>
          <div class="platform_item">
            <img
              src="~@/assets/images/mo_new/platform/img05.png"
              class="platform_img"
              alt="investment 테마 투자 초보자도 쉽게 투자멘토가 되어드릴게요."
            />
          </div>

          <!-- <div class="platform_item">
            <img
              src="~@/assets/images/mo_new/platform/img07.png"
              class="platform_img"
              alt="event 막주는 혜택 랜덤주식증정, 무료 수수료"
              @click="link()"
            /><a href="#" class="platform_link"
              ><span class="blind">혜택 받으러 가기</span></a
            >
          </div> 2025-12-24 삭제 -->

          <div class="platform_item">
            <img
              src="~@/assets/images/mo_new/platform/img08.png"
              class="platform_img"
              alt="investment 수익률 공유하기 내 수익률 올라도, 떨어져도 힙하게 공유하는 센스"
            />
          </div>
          <div class="platform_item">
            <img
              src="~@/assets/images/mo_new/platform/img09.png"
              class="platform_img"
              alt="loan 신용/대출 자금이 부족한 순간 간편, 신속하게!"
            />
          </div>
          <div class="platform_item">
            <img
              src="~@/assets/images/mo_new/platform/img10.png"
              class="platform_img"
              alt="community 미니톡 내 주식에 무슨일이? 미니톡에서 확인하세요."
            />
          </div>
        </div>
      </section>

      <!-- Careers -->
      <section class="section_career">
        <h2>
          <img
            src="~@/assets/images/mo_new/img_career_tit.svg"
            class="career_tit"
            alt="Careers"
          />
        </h2>
        <div
          class="career_area"
          :class="{
            career01: dateRandowNumber === 1,
            career02: dateRandowNumber === 2,
            career03: dateRandowNumber === 3,
            career04: dateRandowNumber === 4,
          }"
        >
          <!-- career01 career02 career03 career04 중에 랜덤으로 한장 나옴 -->
          <div class="idcard idcard01">
            <img
              src="~@/assets/images/mo_new/career/idcard1.png"
              class="career_img"
              alt="사원증 이미지"
            />
          </div>
          <div class="idcard idcard02">
            <img
              src="~@/assets/images/mo_new/career/idcard2.png"
              class="career_img"
              alt="사원증 이미지"
            />
          </div>
          <div class="idcard idcard03">
            <img
              src="~@/assets/images/mo_new/career/idcard3.png"
              class="career_img"
              alt="사원증 이미지"
            />
          </div>
          <div class="idcard idcard04">
            <img
              src="~@/assets/images/mo_new/career/idcard4.png"
              class="career_img"
              alt="사원증 이미지"
            />
          </div>
          <p class="career_txt">
            열정, 도전, 전문역량을 <br />갖춘 변화주도형 <br />인재를 모십니다.
          </p>
          <a
            href="https://recruit.truefriend.com/announcementList"
            target="_blank"
          >
            <button type="button" class="btn_career">
              <span>채용공고 보기</span>
            </button>
          </a>
        </div>
      </section>

      <!-- 이용약관 -->
      <section class="section_term">
        <h2>
          <img
            src="~@/assets/images/mo_new/img_term_tit.svg"
            class="term_tit"
            alt="이용약관"
          />
        </h2>
        <ul class="term_list">
          <li
            v-for="(item, index) in termsList.filter(
              (x, index) => index < 10 * count
            )"
            v-bind:key="index"
          >
            <p class="btn_term_txt" @click="pdfUrl(item.pdf, item.type)">
              {{ item.title }}
            </p>
            <button
              type="button"
              class="btn_term_down"
              @click="pdfUrl(item.pdf, item.type)"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 13.0908V15.6577C17 15.8467 16.8259 15.9999 16.6111 15.9999H3.38889C3.17411 15.9999 3 15.8467 3 15.6577V13.0908"
                  stroke="#333333"
                  stroke-width="1.2"
                  stroke-linecap="round"
                />
                <path
                  d="M10 4V12"
                  stroke="#333333"
                  stroke-width="1.2"
                  stroke-linecap="round"
                />
                <path
                  d="M13.6466 8.93988L10 12.5001C10 12.5001 8.58457 11.0823 6.35337 8.8103"
                  stroke="#333333"
                  stroke-width="1.2"
                  stroke-linecap="round"
                />
                <path
                  d="M13.6466 8.93988L10 12.5001C10 12.5001 8.58457 11.0823 6.35337 8.8103"
                  stroke="#333333"
                  stroke-linecap="square"
                />
              </svg>
              <span class="blind">다운로드 버튼</span>
            </button>
          </li>
        </ul>
        <button type="button" class="btn_term_more" @click="paging()">
          <span
            >더보기 ({{ 10 * count > 20 ? 28 : 10 * count }}/{{
              termsList.length
            }})</span
          >
        </button>
      </section>

      <!-- 투자 유의사항 -->
      <SectionToggle />
    </div>

    <!-- 스크롤 탑 버튼 -->
    <button type="button" class="btn_top" @click="scrollTop()" v-if="btnTop">
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="20" cy="20" r="20" fill="black" />
        <path
          d="M25.6155 18.0476L19.6526 8.63672L14.0909 19.1109L19.8532 15.7728V31.8185"
          stroke="white"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span class="blind">위로가기</span>
    </button>

    <!-- 앱 다운로드 -->
    <div class="btn_fixed">
      <button type="button" class="btn_app_down" @click="download()">
        <svg
          width="81"
          height="60"
          viewBox="0 0 81 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.34064 5.276C2.34064 6.449 2.98664 7.112 3.88764 7.112C4.82264 7.112 5.46864 6.449 5.46864 5.276C5.46864 4.12 4.82264 3.474 3.88764 3.474C2.98664 3.474 2.34064 4.12 2.34064 5.276ZM7.47464 5.276C7.47464 7.418 5.99564 8.931 3.88764 8.931C1.81364 8.931 0.317645 7.418 0.317645 5.276C0.317645 3.151 1.81364 1.655 3.88764 1.655C5.99564 1.655 7.47464 3.151 7.47464 5.276ZM11.4016 14.49V13.113H5.19664V14.49H11.4016ZM11.4016 11.379V9.968H13.6116V16.275H2.96964V9.968H5.19664V11.379H11.4016ZM11.4866 0.821999H13.6116V9.322H11.4866V5.888H10.2626V9.22H8.17164V1.111H10.2626V4.069H11.4866V0.821999ZM22.4797 4.069V10.869C24.7067 10.835 26.5597 10.716 28.5827 10.376L28.8037 12.229C26.4407 12.654 24.2987 12.739 21.5787 12.739H20.2357V2.25H27.5457V4.069H22.4797ZM34.1757 6.585V8.438H31.8977V16.496H29.6537V0.804999H31.8977V6.585H34.1757ZM42.3513 2.879C40.3963 2.879 39.1553 3.372 39.1553 4.341C39.1553 5.31 40.3963 5.803 42.3513 5.803C44.3403 5.803 45.5643 5.31 45.5643 4.341C45.5643 3.372 44.3403 2.879 42.3513 2.879ZM42.3513 7.588C38.9853 7.588 36.7243 6.33 36.7243 4.341C36.7243 2.369 38.9853 1.094 42.3513 1.094C45.7343 1.094 47.9783 2.369 47.9783 4.341C47.9783 6.33 45.7343 7.588 42.3513 7.588ZM39.2063 11.498V14.405H47.9103V16.19H36.9283V11.498H39.2063ZM35.2793 8.404H49.4573V10.189H43.6433V12.875H41.3483V10.189H35.2793V8.404ZM59.112 12.909H65.096V14.745H50.918V12.909H56.868V10.58H52.55V5.276H61.288V3.593H52.533V1.808H63.498V7.027H54.777V8.778H63.855V10.58H59.112V12.909ZM79.2217 8.03V9.815H68.2057V2.097H79.1027V3.916H70.4497V8.03H79.2217ZM66.5567 12.756H80.7347V14.592H66.5567V12.756Z"
            fill="white"
          />
        </svg>
        <span class="blind">앱 다운로드</span>
      </button>
    </div>
  </div>
</template>
<script>
import SectionToggle from "@/components/SectionToggle";
import Animation from "../plugins/animation";

export default {
  components: {
    SectionToggle,
  },
  data() {
    return {
      count: 1,
      termsList,
      navVisible: false,
      hederShow: true,
      initialX: null,
      initialY: null,
      slideCount: 0,
      dateRandowNumber: (new Date().getTime() % 4) + 1,
      scrollLocation: 0,
      slideUpCheck: false,
      btnTop: false,
    };
  },
  mounted() {
    //document.body.style.overflow = "hidden";
    window.addEventListener("touchstart", this.initTouch);
    window.addEventListener("touchmove", this.swipeDirection);
    window.addEventListener("scroll", () => {
      this.scrollLocation = document.documentElement.scrollTop; // 현재 스크롤바 위치

      if (this.scrollLocation < 450) {
        this.slideCount = 0;
      } else if (this.scrollLocation > 450 && this.scrollLocation < 1285) {
        this.slideCount = 1;
      } else if (this.scrollLocation > 1285 && this.scrollLocation < 2170) {
        this.slideCount = 2;
      } else if (this.scrollLocation > 2170 && this.scrollLocation < 3055) {
        this.slideCount = 3;
      } else if (this.scrollLocation > 3055 && this.scrollLocation < 3940) {
        this.slideCount = 4;
      } else if (this.scrollLocation > 3940 && this.scrollLocation < 4795) {
        this.slideCount = 5;
      } else {
        this.slideCount = 6;
      }

      if (
        this.scrollLocation >
          document.querySelector(".section_main").clientHeight - 100 &&
        this.scrollLocation <
          document.querySelector(".section_main").clientHeight +
            document.querySelector(".section_slide").clientHeight
      ) {
        this.hederShow = false;
      } else {
        this.hederShow = true;
      }

      if (
        document.querySelector(".section_main").clientHeight +
          document.querySelector(".section_slide").clientHeight +
          document.querySelector(".section_platform").clientHeight +
          document.querySelector(".section_career").clientHeight <
        this.scrollLocation
      ) {
        this.btnTop = true;
      } else {
        this.btnTop = false;
      }
    });
    this.animationPlay();
  },
  methods: {
    goSlide(requestIdx) {
      if (requestIdx === 1) {
        //About
        this.slideCount = 1;
        const slide = document.querySelector(`.section_slide`);
        slide.scrollIntoView({ behavior: "smooth" });
      } else if (requestIdx === 2) {
        document.body.style.overflow = "auto";
        this.slideCount = 5;
        //Career
        const terms = document.querySelector(`.section_career`);
        terms.scrollIntoView({ behavior: "smooth" });
      } else if (requestIdx === 3) {
        document.body.style.overflow = "auto";
        //이용약관
        this.slideCount = 5;
        const terms = document.querySelector(`.section_term`);
        terms.scrollIntoView({ behavior: "smooth" });
      }
      this.navVisible = false;
    },
    scrollTop() {
      this.slideCount = 0;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    pdfUrl(seqNo, pdfStatus) {
      let url = `${window.location.protocol}//${window.location.host}/public/terms/service/${seqNo}.pdf`;
      if (pdfStatus) {
        if (pdfStatus === "credit") {
          url = `${window.location.protocol}//${window.location.host}/public/terms/credit/${seqNo}.pdf`;
        }
        if (pdfStatus === "secured") {
          url = `${window.location.protocol}//${window.location.host}/public/terms/secured/${seqNo}.pdf`;
        }
      }
      location.href = url;
    },
    paging() {
      this.count = this.count + 1;
    },
    recruit() {
      location.href = "https://recruit.truefriend.com/announcementList";
    },
    download() {
      const url = IS_MOBILE.isAndroid()
        ? "https://play.google.com/store/apps/details?id=com.truefriend.ministock"
        : "https://apps.apple.com/app/id1517001633";
      location.href = url;
    },
    initTouch(e) {
      this.initialX = `${e.touches ? e.touches[0].clientX : e.clientX}`;
      this.initialY = `${e.touches ? e.touches[0].clientY : e.clientY}`;
    },
    swipeDirection(e) {
      if (this.initialX !== null && this.initialY !== null) {
        const currentX = `${e.touches ? e.touches[0].clientX : e.clientX}`,
          currentY = `${e.touches ? e.touches[0].clientY : e.clientY}`;

        let diffX = this.initialX - currentX,
          diffY = this.initialY - currentY;

        Math.abs(diffX) > Math.abs(diffY)
          ? 0 < diffX
            ? console.log("to left")
            : console.log("to right")
          : 0 < diffY
          ? console.log("to up")
          : console.log("to Down");

        this.initialX = null;
        this.initialY = null;
      }
    },
    animationPlay() {
      let path = this.localCheck()
        ? "/assets/json/m"
        : "/stock/br/assets/json/m";
      for (let i = 1; i < 6; i++) {
        Animation.loadLottieSetting(
          `#slide_lottie${i}`,
          true,
          true,
          2,
          `${path}${i}.json`
        );
      }
    },
    goSlideDown() {
      //document.body.style.overflow = "hidden";
      if (this.slideCount === 0) {
        this.slideCount = 1;
        setTimeout(() => {
          const slide = document.querySelector(".section_slide");
          slide.scrollIntoView({ behavior: "smooth" });
        }, 200);
      } else if (this.slideCount > 0 && this.slideCount < 6) {
        this.slideCount++;

        if (this.slideCount === 6) {
          setTimeout(() => {
            const platform = document.querySelector(".section_platform");
            platform.scrollIntoView({ behavior: "smooth" });
            document.body.style.overflow = "auto";
          }, 200);
        } else {
          const slide = document.querySelector(".section_slide");
          slide.scrollIntoView();
        }
      } else {
        if (this.scrollLocation < 467) {
          setTimeout(() => {
            const platform = document.querySelector(".section_platform");
            platform.scrollIntoView({ behavior: "smooth" });
            document.body.style.overflow = "auto";
          }, 200);
        } else {
          document.body.style.overflow = "auto";
        }
      }
    },
    goSlideUp() {
      //document.body.style.overflow = "hidden";
      console.log("슬라이드 카운트:" + this.slideCount);
      if (
        this.slideCount === 6 &&
        this.scrollLocation <
          document.querySelector(".section_main").clientHeight +
            document.querySelector(".section_slide").clientHeight
      ) {
        this.slideCount = 5;
        setTimeout(() => {
          const slide = document.querySelector(".section_slide");
          slide.scrollIntoView({ behavior: "smooth" });
        }, 200);
      } else if (this.slideCount > 0 && this.slideCount < 6) {
        this.slideCount--;
        if (this.slideCount === 0) {
          setTimeout(() => {
            const slide = document.querySelector(".section_main");
            slide.scrollIntoView({ behavior: "smooth" });
          }, 200);
        } else {
          const slide = document.querySelector(".section_slide");
          slide.scrollIntoView();
        }
      } else {
        document.body.style.overflow = "auto";
        // console.log("기타 슬라이드");
      }
    },
    localCheck() {
      return window.location.origin.search("localhost") > 0;
    },
    link() {
      location.href =
        "https://mini.koreainvestment.com/stock/event/index1.html";
    },
  },
};
const termsList = [
  {
    num: "29",
    title: "해외 ETP 거래에 관한 위험고지",
    pdf: "29", // same oversea_etp_terms.pdf
  },
  {
    num: "28",
    title: "개인(신용)정보 수집·이용 동의서(고객편의서비스 제공용)",
    pdf: "28",
  },
  {
    num: "24",
    title: "개인(신용)정보 수집·이용·제공 동의서(해외상품용)",
    pdf: "23",
  },
  {
    num: "23",
    title:
      "개인(신용)정보 수집·이용·제공·조회 동의서(신용공여/파생/미수거래용)",
    pdf: "22",
  },

  {
    num: "22",
    title: "개인(신용)정보 수집·이용동의서(금융거래설정용)",
    pdf: "20",
  },
  {
    num: "21",
    title: "주식거래설명서",
    pdf: "21",
  },
  {
    num: "19",
    title: "미수동결제도 안내",
    pdf: "19",
  },
  {
    num: "18",
    title: "온라인 거래 장애 발생시 보상기준 및 절차",
    pdf: "18",
  },
  {
    num: "17",
    title: "고객정보 취급방침",
    pdf: "17",
  },
  {
    num: "16",
    title: "비상시 주문안내",
    pdf: "16",
  },
  {
    num: "15",
    title: "예금보험관계 설명서",
    pdf: "15",
  },
  {
    num: "14",
    title: "불법 목적 차명거래 금지 및 접근매체 양도 불법성 안내",
    pdf: "14",
  },
  {
    num: "13",
    title: "QI투자제한동의서",
    pdf: "13",
  },
  {
    num: "11",
    title: "외화증권 거래설명서",
    pdf: "11",
  },
  {
    num: "10",
    title: "미니스탁서비스 설명서",
    pdf: "10",
  },
  {
    num: "9",
    title: "외화증권매매거래계좌설정약관",
    pdf: "09",
  },
  {
    num: "8",
    title: "이체거래이용에관한약관",
    pdf: "08",
  },
  {
    num: "7",
    title: "수익증권저축약관",
    pdf: "07",
  },
  {
    num: "6",
    title: "매매거래계좌설정약관",
    pdf: "06",
  },
  {
    num: "5",
    title: "정보제공서비스약관",
    pdf: "05",
  },
  {
    num: "4",
    title: "증권거래기본약관",
    pdf: "04",
  },
  {
    num: "3",
    title: "전자금융거래이용에 관한 세부약관",
    pdf: "03",
  },
  {
    num: "2",
    title: "전자금융거래이용에 관한 기본약관",
    pdf: "02",
  },
  {
    num: "1",
    title: "일중매매거래/시스템매매 위험고지",
    pdf: "01",
  },
  {
    num: "01",
    title: "신용거래약관",
    pdf: "1",
    type: "credit",
  },
  {
    num: "02",
    title: "신용거래(융자,대주) 거래설명서",
    pdf: "2",
    type: "credit",
  },
  {
    num: "03",
    title: "증권 종합대출 약관",
    pdf: "1",
    type: "secured",
  },
  {
    num: "04",
    title: "증권종합대출 거래설명서",
    pdf: "2",
    type: "secured",
  },
];

var IS_MOBILE = {
  isAndroid: function() {
    return navigator.userAgent.match(/Android/i);
  },
  isBlackBerry: function() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  isIOS: function() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  isOpera: function() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  isWindows: function() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
    return (
      IS_MOBILE.isAndroid() ||
      IS_MOBILE.isBlackBerry() ||
      IS_MOBILE.isIOS() ||
      IS_MOBILE.isOpera() ||
      IS_MOBILE.isWindows()
    );
  },
};
</script>
